import {connect} from '@modifi/redux'

import HighLimitDocUploadDialog, {HighLimitDocUploadDialogProps} from './HighLimitDocUploadDialog'
import {selectSavePending, selectSaveErrorMessage, aSavePage, selectInitialFormData} from './form'
import {aHideBuyerForm} from '../../buyer-details/store/view'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {params: {externalTradePartnerId: string}}
): Pick<HighLimitDocUploadDialogProps, 'formData' | 'savePending' | 'errorMessage'> => ({
  formData: selectInitialFormData(state, ownProps.params.externalTradePartnerId),
  savePending: selectSavePending(state),
  errorMessage: selectSaveErrorMessage(state),
})

const mapDispatchToProps = {
  submit: aSavePage,
  hideBuyerForm: aHideBuyerForm,
}

export const DIALOG_NAME = 'seller-trade-partner/high-limit-doc-upload'
export default connect(mapStateToProps, mapDispatchToProps)(HighLimitDocUploadDialog)
